<template>
  <div class="article">
    <div class="title">拿督斯里洪子晴爵士为团长率国际潮商会长俱乐部出席第十二届国际潮青联谊年会-马来西亚盛会</div>
    <div class="info">作者：晴天集团    发布于：2025-07-11 19:19</div>
    <p>马来西亚潮州公会联合会青年团（简称马潮联青）承办的2025年第十二届国际潮青联谊会于2025年7月8日至10日在马来西亚雪兰莪州万达镇One World Hotel（万达酒店）及M World Hotel隆重举行。汇聚全球逾1200名潮籍青年共襄盛举，年会以“潮聚大马，魅力所在”为主题，除了呈现马来西亚的多元文化特色，同时也颁发了多份奖项，表扬各地潮人所作出的贡献。</p>
    <p>盛会汇聚了来自全球各地的潮籍青年才俊，成为潮商文化传承与交流的重要平台。拿督斯里洪子晴爵士作为国际潮商会长俱乐部的团长，率团出席此次年会。拿督斯里洪子晴爵士长期以来致力推动潮商文化在国际间的传播与发展，带领的国际潮商会长俱乐部在全球商业领域具有广泛影响力。此次出席国际潮青联谊年会，拿督斯里洪子晴爵士表示：“潮青是潮商群体的未来与希望，传承潮商坚韧不拔、团结奋进的精神。”</p>
    <p>第12届国际潮青联谊年会出席者包括马来西亚潮州公会联合会总会长、年会首席主席林家光，国际潮青联合会执行会长、年会大会主席拿督黄瑞雷，马潮联会永远名誉主席、年会名誉主席拿督吴源盛，马来西亚旅游艺术及文化部代表翁荣华，万达酒店执行主席丹斯里拿督张昌，马来西亚民政党全国主席拿督刘华才博士，汕头市委副书记赖小卫，汕头大学党委书记唐锐，国际潮商会长俱乐部名誉主席拿督斯里洪子晴爵士，国际潮团总会执行主席、国际潮青联合会永远会长陈幼南博士，国际潮青联合会永远会长吴南祥、赵利生，永远会长、法国国会前议员陈文雄，永远会长许展雄、叶志光，国际潮团总会荣誉会长、国际潮青联合会永远会长陈才雄，国际潮青联合会永远会长张俊勇，国际潮团总会执行主席兼秘书长、国际潮青联合会会长李奕标，国际潮青联合会执行会长陈思宇、黄进达，国际潮商会长俱乐部主席团主席林裕、赵泫岚、陈耿彬，茶业发展委员会执行主席詹志浩，秘书处副秘书长陈捷煌，国际潮商会长俱乐部总发起召集人张汉松等。</p>
    <p>广大潮籍青年以本届年会为契机，与中马两国青年、广大华人华侨，以及两国社会各界，充分发挥自身独特优势，积极奋进，努力拼搏，为弘扬中华优秀传统文化、密切中国与世界各国的友好交流、推动构建中马高水平战略性命运共同体继续贡献自己的青春和力量。</p>
    <img src="@/assets/img/article/0711/1.webp" alt="">
    <p class="img-alt-content">拿督斯里、国际潮商会长俱乐部名誉主席洪子晴爵士（居中）与国际潮商会长俱乐部团员合影</p>
    <img src="@/assets/img/article/0711/2.webp" alt="">
    <p class="img-alt-content">右5:汕头市委副书记赖小卫<br>
      右4:国际潮商会长俱乐部名誉主席、香港中华工商总会执行主席、本次会议代表团团长拿督斯里洪子晴爵士<br>
      左4:国际潮商会长俱乐部共间主席、惠州市潮汕商会会长姚文专<br>
      左3:团际潮商会长俱乐部主房团成员赵泫岚<br>
      左2:国际潮商会长俱乐部主席团主席林裕<br>
      左1:国际潮商会长俱乐部主席团成员陈耿彬<br>
      右2:国际潮商会长俱乐部"茶业发展委员会主席希志浩<br>
      右1:国际潮商会长俱乐部秘书处副秘书长陈煌<br>
      右3:国际潮商会长俱乐部总发起召集人张汉松<br>
    </p>
    <img src="@/assets/img/article/0711/3.webp" alt="">
    <p class="img-alt-content">拿督斯里、国际潮商会长俱乐部名誉主席洪子晴爵士（居中）与国际潮商会长俱乐部名誉主席陈幼南（右五）合影</p>
    <img src="@/assets/img/article/0711/4.webp" alt="">
    <p class="img-alt-content">团长、拿督斯里洪子晴爵士（居中）与国际潮商会长俱乐部团员合影</p>
    <img src="@/assets/img/article/0711/5.webp" alt="">
    <p class="img-alt-content">拿督斯里、国际潮商会长俱乐部名誉主席洪子晴爵士（右二）与国际潮商会长俱乐部团员合影
    </p>
    <img src="@/assets/img/article/0711/6.webp" alt="">
    <p class="img-alt-content">拿督斯里、国际潮商会长俱乐部名誉主席洪子晴爵士（居中）与国际潮商会长俱乐部团员合影</p>
    <img src="@/assets/img/article/0711/7.webp" alt="">
    <p class="img-alt-content">拿督斯里、国际潮商会长俱乐部名誉主席洪子晴爵士与汕头大学党委书记唐锐合影</p>

  </div>
</template>

<script>
  export default {
    name: '1',
    components: {},
    data() {
      return {}
    }
  }
</script>

<style scoped lang="scss">
  .article{
    width: 70%;
    margin: 20px auto;
    font-family: $font-family;
    .title{
      font-size: 1.4rem;
      font-weight: bold;
      line-height: 50px;
      text-align: center;
    }

    .info{
      height: 28px;
      line-height: 28px;
      border-bottom: 1px #e8e8e8 solid;
      margin: 0;
      text-align: center;
      font-size: 0.8rem;
    }

    p{
      font-size: $content-font-size;
      color: #000000;
      line-height: 2;
      margin: 20px 0;
    }

    img{
      width: 60%;
      margin-left: 20%;
    }

    .img-alt{
      text-align: center;
      line-height: 1;
      margin: 6px 0;
      padding-top: 10px;
      color: #2f2e2e;
      font-size: 0.9rem;
    }

    .img-alt-content{
      text-align: center;
      line-height: 1;
      margin: 6px 0;
      padding-top: 5px;
      padding-bottom: 15px;
      color: #2f2e2e;
      font-size: 0.9rem;
    }
  }

  @media (max-width: 768px) {
    .article{
      width: 90%;
      margin: 20px auto;
      .title{
        padding-top: 10px;
        padding-bottom: 8px;
        font-size: 1.1rem;
        font-weight: bold;
        line-height: 1.3;
        text-align: center;
      }

      .info{
        height: 28px;
        line-height: 28px;
        border-bottom: 1px #e8e8e8 solid;
        margin: 0;
        text-align: center;
        font-size: 0.8rem;
      }

      p{
        font-size: $phone-content-font-size;
        color: #000000;
        line-height: 2;
        margin: 20px 0;
      }

      img{
        width: 80%;
        margin-left: 10%;
      }

      .img-alt{
        text-align: center;
        line-height: 1;
        margin: 6px 0;
        color: #2f2e2e;
        padding-top: 5px;
        font-size: 0.8rem;
      }
      .img-alt-content{
        text-align: center;
        line-height: 1;
        margin: 6px 0;
        padding-top: 5px;
        padding-bottom: 15px;
        color: #2f2e2e;
        font-size: 0.8rem;
      }
    }
  }

  @media (max-width: 480px) {
    .article{
      width: 100vw;
      padding: 0 10px;
      box-sizing: border-box;
      margin: 20px auto;
      .title{
        padding-top: 10px;
        padding-bottom: 8px;
        font-size: 1.1rem;
        font-weight: bold;
        line-height: 1.3;
        text-align: center;
      }

      .info{
        height: 28px;
        line-height: 28px;
        border-bottom: 1px #e8e8e8 solid;
        margin: 0;
        text-align: center;
        font-size: 0.8rem;
      }

      p{
        font-size: $phone-content-font-size;
        color: #000000;
        line-height: 2;
        margin: 20px 0;
      }

      img{
        width: 100%;
        margin: 0;
      }

      .img-alt{
        text-align: center;
        line-height: 1;
        font-size: 0.7rem;
        margin: 6px 0;
        color: #666;
      }
    }
  }
</style>
